$(document).ready(function() {

    // Service sub menu reveal
    // $('.service-drop').click(function() {
    //     $('.sub-menu').toggleClass('active');
    //     $('.service-drop .fa-angle-down').toggleClass('rotate');
    // });

    // $(document).on("click", function(e) {
    //     if ($(e.target).is(".service-drop") === false) {
    //         $('.sub-menu').removeClass('active');
    //         $('.service-drop .fa-angle-down').removeClass('rotate');
    //     }
    // });

    // Full take over navigation, used on smaller devices
    $('.menu-reveal').click(function() {
        $('.menu').toggleClass('active');
    });

    $.fn.toggleClick = function() {
        var methods = arguments;    // Store the passed arguments for future reference
        var count = methods.length; // Cache the number of methods

        // Use return this to maintain jQuery chainability
        // For each element you bind to
        return this.each(function(i, item){
            // Create a local counter for that element
            var index = 0;

            // Bind a click handler to that element
            $(item).on('click', function() {
                // That when called will apply the 'index'th method to that element
                // the index % count means that we constrain our iterator between 0
                // and (count-1)
                return methods[index++ % count].apply(this, arguments);
            });
        });
    };

    $('.menu-reveal').toggleClick(function() {
        $(this).html('<div class="nav-item"><i class="fa fa-times" aria-hidden="true"></i> <span>Close</span></div>');
    }, function() {
        $(this).html('<div class="nav-item"><i class="fa fa-bars" aria-hidden="true"></i> <span>Menu</span></div>');
    });

    // Enquiry take over

    $('.make-enquiry').click(function() {
        $('.enquiry').addClass('active');
        $('body').addClass('no-scroll');
    });

    $('.close-enquiry').click(function() {
        $('.enquiry').removeClass('active');
        $('body').removeClass('no-scroll');
    });

    // DL functions
    $(".dropdown dt span").click(function() {
        $(".dropdown dd ul").fadeToggle( "fast", "linear" );;
    });

    $(".dropdown dd ul li a").click(function() {
        var text = $(this).html();
        $(".dropdown dt span").html(text);
        $(".dropdown dd ul").hide();
        var source = $("#source");
        source.val($(this).find("span.value").html())
    });

    // Smooth Scrolling
    $('a[href^="#"].page-anchor').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if( target.length ) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top - 150
            }, 2000);
        }
    });

    // Animated elements on viewport
    $('.fade-in').each(function(){
        var _this = this;
        var inview = new Waypoint({
            element: _this,
            handler: function() {
                $(this.element).addClass('in-view');
            },
            offset: '90%'
        });

    });

    // Scroll Fixed
    $('.page-nav').scrollToFixed({
        marginTop: 100
    });

    // Button clicks, checkbox interactions
    $(".close-enquiry").click(function () {
        $('.enquiry-form input:checkbox').prop('checked',false);
    });

    $("#btn_basicShopifySetup").click(function () {
        $('.enquiry-form input:checkbox[id=basicShopifySetup]').prop('checked',true);
    });

    $("#btn_customShopifyDesignBuild").click(function () {
        $('.enquiry-form input:checkbox[id=customShopifyDesignBuild]').prop('checked',true);
    });

    $("#btn_retainerSupportOnlineMarketing").click(function () {
        $('.enquiry-form input:checkbox[id=retainerSupportOnlineMarketing]').prop('checked',true);
    });

    $("#btn_bespoke").click(function () {
        $('.enquiry-form input:checkbox[id=bespokeAppPluginIntegrations]').prop('checked',true);
    });
});

// some element to monitor
var slide = $(".plumo");

// hook up the watcher
slide.watch({
    // specify CSS styles or attribute names to monitor
    properties: "attr_class",
    callback: watchPager
});

function watchPager(data, i) {
    // element affected is 'this'
    var slide = $(this);
    var pager = $(".casestudy-pager");

    pager.removeClass("invert")
        .removeClass("");
    if (slide.hasClass("cycle-slide-active"))
        pager.addClass("invert");
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js